/**
 * Clickable, sortable `<th>` — a feature-scoped replacement for the legacy
 * `component/Table/Th` (left untouched; still used by other un-migrated
 * pages). Not in design_system_export's spec set — composed from Icon,
 * same precedent as CalendarSelect/RadioCardGrid/ConfirmDialog. Extracted
 * here after UsersPage and OrganizationsPage each independently hand-rolled
 * a byte-identical page-scoped copy.
 *
 * @param {string=} orderField - omit for a non-sortable column
 * @param {'asc'|'desc'|null} currentDirection
 * @param {function} onOrder - (orderField, currentDirection) => void
 */
import React, { useCallback } from "react";
import classNames from "classnames";
import Icon from "../icons/Icon";
import styles from "./SortableTh.module.scss";

const SortableTh = ({ children, orderField, currentDirection, onOrder }) => {
  const sortable = !!orderField;

  const onClick = useCallback(
    (e) => {
      e.preventDefault();
      onOrder(orderField, currentDirection);
    },
    [onOrder, orderField, currentDirection]
  );

  let icon = null;
  if (sortable) {
    if (currentDirection === "asc") {
      icon = <Icon name="ChevronUp" size={16} className={styles.sortIcon} />;
    } else if (currentDirection === "desc") {
      icon = <Icon name="ChevronDown" size={16} className={styles.sortIcon} />;
    } else {
      icon = (
        <Icon
          name="SwitchVertical01"
          size={16}
          className={classNames(styles.sortIcon, styles.sortIconIdle)}
        />
      );
    }
  }

  return (
    <th
      scope="col"
      className={classNames({ [styles.thSortable]: sortable })}
      onClick={sortable ? onClick : undefined}
    >
      <span className={styles.thLabel}>
        {children}
        {icon}
      </span>
    </th>
  );
};

export default SortableTh;
